import DeliveringGreatDrivers1 from "../../images/CustomerStories/DeliveringGreatDrivers/1.png";
import DeliveringGreatDrivers2 from "../../images/CustomerStories/DeliveringGreatDrivers/2.png";
import DeliveringGreatDrivers3 from "../../images/CustomerStories/DeliveringGreatDrivers/3.png";
import DeliveringGreatDrivers4 from "../../images/CustomerStories/DeliveringGreatDrivers/4.png";
import DeliveringGreatDrivers5 from "../../images/CustomerStories/DeliveringGreatDrivers/5.png";
import DeliveringGreatDrivers6 from "../../images/CustomerStories/DeliveringGreatDrivers/6.png";
import DeliveringGreatDrivers7 from "../../images/CustomerStories/DeliveringGreatDrivers/7.png";
import DeliveringGreatDrivers8 from "../../images/CustomerStories/DeliveringGreatDrivers/8.png";
import DeliveringGreatDrivers9 from "../../images/CustomerStories/DeliveringGreatDrivers/9.png";
import DeliveringGreatDrivers10 from "../../images/CustomerStories/DeliveringGreatDrivers/10.png";
import DeliveringGreatDrivers11 from "../../images/CustomerStories/DeliveringGreatDrivers/11.png";
import DeliveringGreatDrivers12 from "../../images/CustomerStories/DeliveringGreatDrivers/12.png";
import DeliveringGreatDrivers13 from "../../images/CustomerStories/DeliveringGreatDrivers/13.png";
import DeliveringGreatDrivers14 from "../../images/CustomerStories/DeliveringGreatDrivers/14.png";
import DeliveringGreatDrivers15 from "../../images/CustomerStories/DeliveringGreatDrivers/15.png";
import DeliveringGreatDrivers16 from "../../images/CustomerStories/DeliveringGreatDrivers/16.png";
import DeliveringGreatDrivers17 from "../../images/CustomerStories/DeliveringGreatDrivers/17.png";
import DeliveringGreatDrivers18 from "../../images/CustomerStories/DeliveringGreatDrivers/18.png";

import SomeOfOurFans1 from "../../images/CustomerStories/SomeOfOurFans/1.png";
import SomeOfOurFans2 from "../../images/CustomerStories/SomeOfOurFans/2.png";
import SomeOfOurFans3 from "../../images/CustomerStories/SomeOfOurFans/3.png";
import SomeOfOurFans4 from "../../images/CustomerStories/SomeOfOurFans/4.png";
import SomeOfOurFans5 from "../../images/CustomerStories/SomeOfOurFans/5.png";
import SomeOfOurFans6 from "../../images/CustomerStories/SomeOfOurFans/6.png";
import SomeOfOurFans7 from "../../images/CustomerStories/SomeOfOurFans/7.png";
import SomeOfOurFans8 from "../../images/CustomerStories/SomeOfOurFans/8.png";
import SomeOfOurFans9 from "../../images/CustomerStories/SomeOfOurFans/9.png";
import SomeOfOurFans10 from "../../images/CustomerStories/SomeOfOurFans/10.png";
import SomeOfOurFans11 from "../../images/CustomerStories/SomeOfOurFans/11.png";
import SomeOfOurFans12 from "../../images/CustomerStories/SomeOfOurFans/12.png";

import FinancialBenefits1 from "../../images/CustomerStories/FinancialBenefits/1.png";
import FinancialBenefits2 from "../../images/CustomerStories/FinancialBenefits/2.png";
import FinancialBenefits3 from "../../images/CustomerStories/FinancialBenefits/3.png";
import FinancialBenefits4 from "../../images/CustomerStories/FinancialBenefits/4.png";
import FinancialBenefits5 from "../../images/CustomerStories/FinancialBenefits/5.png";
import FinancialBenefits6 from "../../images/CustomerStories/FinancialBenefits/6.png";

import HowDrivosityHelps1 from "../../images/CustomerStories/HowDrivosityHelps/1.png";
import HowDrivosityHelps2 from "../../images/CustomerStories/HowDrivosityHelps/2.png";
import HowDrivosityHelps3 from "../../images/CustomerStories/HowDrivosityHelps/3.png";
import HowDrivosityHelps4 from "../../images/CustomerStories/HowDrivosityHelps/4.png";
import HowDrivosityHelps5 from "../../images/CustomerStories/HowDrivosityHelps/5.png";
import HowDrivosityHelps6 from "../../images/CustomerStories/HowDrivosityHelps/6.png";
import HowDrivosityHelps7 from "../../images/CustomerStories/HowDrivosityHelps/7.png";
import HowDrivosityHelps8 from "../../images/CustomerStories/HowDrivosityHelps/8.png";
import HowDrivosityHelps9 from "../../images/CustomerStories/HowDrivosityHelps/9.png";
import HowDrivosityHelps10 from "../../images/CustomerStories/HowDrivosityHelps/10.png";
import HowDrivosityHelps11 from "../../images/CustomerStories/HowDrivosityHelps/11.png";
import HowDrivosityHelps12 from "../../images/CustomerStories/HowDrivosityHelps/12.png";
import HowDrivosityHelps13 from "../../images/CustomerStories/HowDrivosityHelps/13.png";

import Productivity1 from "../../images/CustomerStories/Productivity/1.png";
import Productivity2 from "../../images/CustomerStories/Productivity/2.png";
import Productivity3 from "../../images/CustomerStories/Productivity/3.png";
import Productivity4 from "../../images/CustomerStories/Productivity/4.png";
import Productivity5 from "../../images/CustomerStories/Productivity/5.png";
import Productivity6 from "../../images/CustomerStories/Productivity/6.png";
import Productivity7 from "../../images/CustomerStories/Productivity/7.png";
import Productivity8 from "../../images/CustomerStories/Productivity/8.png";
import Productivity9 from "../../images/CustomerStories/Productivity/9.png";
import Productivity10 from "../../images/CustomerStories/Productivity/10.png";
import Productivity11 from "../../images/CustomerStories/Productivity/11.png";
import Productivity12 from "../../images/CustomerStories/Productivity/12.png";
import Productivity13 from "../../images/CustomerStories/Productivity/13.png";
import Productivity14 from "../../images/CustomerStories/Productivity/14.png";
import Productivity15 from "../../images/CustomerStories/Productivity/15.png";
import Productivity16 from "../../images/CustomerStories/Productivity/16.png";
import Productivity17 from "../../images/CustomerStories/Productivity/17.png";
import Productivity18 from "../../images/CustomerStories/Productivity/18.png";

import Safety1 from "../../images/CustomerStories/Safety/1.png";
import Safety2 from "../../images/CustomerStories/Safety/2.png";
import Safety3 from "../../images/CustomerStories/Safety/3.png";
import Safety4 from "../../images/CustomerStories/Safety/4.png";
import Safety5 from "../../images/CustomerStories/Safety/5.png";
import Safety6 from "../../images/CustomerStories/Safety/6.png";

import ImpactOnCultureAndOperations1 from "../../images/CustomerStories/ImpactOnCultureAndOperations/1.png";
import ImpactOnCultureAndOperations2 from "../../images/CustomerStories/ImpactOnCultureAndOperations/2.png";
import ImpactOnCultureAndOperations3 from "../../images/CustomerStories/ImpactOnCultureAndOperations/3.png";
import ImpactOnCultureAndOperations4 from "../../images/CustomerStories/ImpactOnCultureAndOperations/4.png";
import ImpactOnCultureAndOperations5 from "../../images/CustomerStories/ImpactOnCultureAndOperations/5.png";
import ImpactOnCultureAndOperations6 from "../../images/CustomerStories/ImpactOnCultureAndOperations/6.png";
import ImpactOnCultureAndOperations7 from "../../images/CustomerStories/ImpactOnCultureAndOperations/7.png";
import ImpactOnCultureAndOperations8 from "../../images/CustomerStories/ImpactOnCultureAndOperations/8.png";
import ImpactOnCultureAndOperations9 from "../../images/CustomerStories/ImpactOnCultureAndOperations/9.png";
import ImpactOnCultureAndOperations10 from "../../images/CustomerStories/ImpactOnCultureAndOperations/10.png";
import ImpactOnCultureAndOperations11 from "../../images/CustomerStories/ImpactOnCultureAndOperations/11.png";
import ImpactOnCultureAndOperations12 from "../../images/CustomerStories/ImpactOnCultureAndOperations/12.png";
import ImpactOnCultureAndOperations13 from "../../images/CustomerStories/ImpactOnCultureAndOperations/13.png";
import ImpactOnCultureAndOperations14 from "../../images/CustomerStories/ImpactOnCultureAndOperations/14.png";
import ImpactOnCultureAndOperations15 from "../../images/CustomerStories/ImpactOnCultureAndOperations/15.png";
import ImpactOnCultureAndOperations16 from "../../images/CustomerStories/ImpactOnCultureAndOperations/16.png";

import CustomerServiceAndSatisfaction1 from "../../images/CustomerStories/CustomerServiceAndSatisfaction/1.png";
import CustomerServiceAndSatisfaction2 from "../../images/CustomerStories/CustomerServiceAndSatisfaction/2.png";
import CustomerServiceAndSatisfaction3 from "../../images/CustomerStories/CustomerServiceAndSatisfaction/3.png";
import CustomerServiceAndSatisfaction4 from "../../images/CustomerStories/CustomerServiceAndSatisfaction/4.png";
import CustomerServiceAndSatisfaction5 from "../../images/CustomerStories/CustomerServiceAndSatisfaction/5.png";

const videos = {
    DeliveringGreatDrivers: [
        {
            image: DeliveringGreatDrivers1,
            url: 'https://www.youtube.com/embed/LxfvUTvgOPQ'
        },
        {
            image: DeliveringGreatDrivers2,
            url: 'https://www.youtube.com/embed/-1fWM3tW5Ck'
        },
        {
            image: DeliveringGreatDrivers3,
            url: 'https://www.youtube.com/embed/lVxwENzMfQY'
        },
        {
            image: DeliveringGreatDrivers4,
            url: 'https://www.youtube.com/embed/iUjzN9uGuwI'
        },
        {
            image: DeliveringGreatDrivers5,
            url: 'https://www.youtube.com/embed/YTdmKWH4lfI'
        },
        {
            image: DeliveringGreatDrivers6,
            url: 'https://www.youtube.com/embed/egMDORff_ok'
        },
        {
            image: DeliveringGreatDrivers7,
            url: 'https://www.youtube.com/embed/YLW8mEjpqF0'
        },
        {
            image: DeliveringGreatDrivers8,
            url: 'https://www.youtube.com/embed/305LJGrvoPI'
        },
        {
            image: DeliveringGreatDrivers9,
            url: 'https://www.youtube.com/embed/fxCISAIkvXM'
        },
        {
            image: DeliveringGreatDrivers10,
            url: 'https://www.youtube.com/embed/NbQWHWEBT0s'
        },
        {
            image: DeliveringGreatDrivers11,
            url: 'https://www.youtube.com/embed/KF7HrhRcMl4'
        },
        {
            image: DeliveringGreatDrivers12,
            url: 'https://www.youtube.com/embed/g-FGwn-mWQ4'
        },
        {
            image: DeliveringGreatDrivers13,
            url: 'https://www.youtube.com/embed/Oo9rC9Lb-5E'
        },
        {
            image: DeliveringGreatDrivers14,
            url: 'https://www.youtube.com/embed/hzzkejohf9s'
        },
        {
            image: DeliveringGreatDrivers15,
            url: 'https://www.youtube.com/embed/j34zWIqyJYY'
        },
        {
            image: DeliveringGreatDrivers16,
            url: 'https://www.youtube.com/embed/o0WXGXnGHpk'
        },
        {
            image: DeliveringGreatDrivers17,
            url: 'https://www.youtube.com/embed/IcUbbv5aEfI'
        },
        {
            image: DeliveringGreatDrivers18,
            url: 'https://www.youtube.com/embed/O0bjYzUXx_U'
        }
    ],
    SomeOfOurFans: [
        {
            image: SomeOfOurFans1,
            url: 'https://www.youtube.com/embed/J5FJFN6WNKI'
        },
        {
            image: SomeOfOurFans2,
            url: 'https://www.youtube.com/embed/Kr3YOn-OkFk'
        },
        {
            image: SomeOfOurFans3,
            url: 'https://www.youtube.com/embed/08JX08tJycE'
        },
        {
            image: SomeOfOurFans4,
            url: 'https://www.youtube.com/embed/gfhZjfESMAQ'
        },
        {
            image: SomeOfOurFans5,
            url: 'https://www.youtube.com/embed/qNPxeiZwbr4'
        },
        {
            image: SomeOfOurFans6,
            url: 'https://www.youtube.com/embed/c9m_lrcQeMY'
        },
        {
            image: SomeOfOurFans7,
            url: 'https://www.youtube.com/embed/zb6GIyjsNyk'
        },
        {
            image: SomeOfOurFans8,
            url: 'https://www.youtube.com/embed/ySpAjaPlUD0'
        },
        {
            image: SomeOfOurFans9,
            url: 'https://www.youtube.com/embed/p_tC-tOcHXo'
        },
        {
            image: SomeOfOurFans10,
            url: 'https://www.youtube.com/embed/1keOfYTv9Rg'
        },
        {
            image: SomeOfOurFans11,
            url: 'https://www.youtube.com/embed/G8bpeZ-gbpM'
        },
        {
            image: SomeOfOurFans12,
            url: 'https://www.youtube.com/embed/E_vYS4-5HmA'
        },
    ],
    FinancialBenefits: [
        {
            image: FinancialBenefits1,
            url: 'https://www.youtube.com/embed/TzvPZm5NRQM'
        },
        {
            image: FinancialBenefits2,
            url: 'https://www.youtube.com/embed/8JsFAzejhao'
        },
        {
            image: FinancialBenefits3,
            url: 'https://www.youtube.com/embed/ihm-9XfDlTU'
        },
        {
            image: FinancialBenefits4,
            url: 'https://www.youtube.com/embed/n0hlFQKaShA'
        },
        {
            image: FinancialBenefits5,
            url: 'https://www.youtube.com/embed/AfoT2WkFZzo'
        },
        {
            image: FinancialBenefits6,
            url: 'https://www.youtube.com/embed/UgJXs-zASBI'
        },
    ],
    HowDrivosityHelps: [
        {
            image: HowDrivosityHelps1,
            url: 'https://www.youtube.com/embed/Tkr9At4dsfQ'
        },
        {
            image: HowDrivosityHelps2,
            url: 'https://www.youtube.com/embed/VWbOsCybI2A'
        },
        {
            image: HowDrivosityHelps3,
            url: 'https://www.youtube.com/embed/aYPPbmynrCI'
        },
        {
            image: HowDrivosityHelps4,
            url: 'https://www.youtube.com/embed/pCbGm03Y8K0'
        },
        {
            image: HowDrivosityHelps5,
            url: 'https://www.youtube.com/embed/qT06X_K1Tcg'
        },
        {
            image: HowDrivosityHelps6,
            url: 'https://www.youtube.com/embed/j5-IGzsjCQ0'
        },
        {
            image: HowDrivosityHelps7,
            url: 'https://www.youtube.com/embed/LaXOFMRT4mw'
        },
        {
            image: HowDrivosityHelps8,
            url: 'https://www.youtube.com/embed/W6GPdYXoW0M'
        },
        {
            image: HowDrivosityHelps9,
            url: 'https://www.youtube.com/embed/gtjJX8FeblY'
        },
        {
            image: HowDrivosityHelps10,
            url: 'https://www.youtube.com/embed/P3TiWWTv2LE'
        },
        {
            image: HowDrivosityHelps11,
            url: 'https://www.youtube.com/embed/GcxV6NiE0JI'
        },
        {
            image: HowDrivosityHelps12,
            url: 'https://www.youtube.com/embed/wlvzXenlmoY'
        },
        {
            image: HowDrivosityHelps13,
            url: 'https://www.youtube.com/embed/8Ydh2rVE2Z0'
        }
    ],
    Productivity: [
        {
            image: Productivity1,
            url: 'https://www.youtube.com/embed/6BglkDniKXU'
        },
        {
            image: Productivity2,
            url: 'https://www.youtube.com/embed/6BglkDniKXU'
        },
        {
            image: Productivity3,
            url: 'https://www.youtube.com/embed/ATjBdpxKhvE'
        },
        {
            image: Productivity4,
            url: 'https://www.youtube.com/embed/LMGrl3h_DOk'
        },
        {
            image: Productivity5,
            url: 'https://www.youtube.com/embed/l2tYpKY6SKw'
        },
        {
            image: Productivity6,
            url: 'https://www.youtube.com/embed/Uu9RuhLmLNE'
        },
        {
            image: Productivity7,
            url: 'https://www.youtube.com/embed/ippOT_Oy8SQ'
        },
        {
            image: Productivity8,
            url: 'https://www.youtube.com/embed/uUVUByrPPqc'
        },
        {
            image: Productivity9,
            url: 'https://www.youtube.com/embed/REr2jeDgnF8'
        },
        {
            image: Productivity10,
            url: 'https://www.youtube.com/embed/tB0DZ5d7DTw'
        },
        {
            image: Productivity11,
            url: 'https://www.youtube.com/embed/LdCltQVgtzk'
        },
        {
            image: Productivity12,
            url: 'https://www.youtube.com/embed/Mste5T6CJxA'
        },
        {
            image: Productivity13,
            url: 'https://www.youtube.com/embed/-nts_PkPn_k'
        },
        {
            image: Productivity14,
            url: 'https://www.youtube.com/embed/4Ip16xUPNoY'
        },
        {
            image: Productivity15,
            url: 'https://www.youtube.com/embed/QXbuU0MjfxE'
        },
        {
            image: Productivity16,
            url: 'https://www.youtube.com/embed/N_TKxhrmRgg'
        },
        {
            image: Productivity17,
            url: 'https://www.youtube.com/embed/FNn7lOxHmtk'
        },
        {
            image: Productivity18,
            url: 'https://www.youtube.com/embed/BvgZryLbny4'
        }
    ],
    Safety: [
        {
            image: Safety1,
            url: 'https://www.youtube.com/embed/8Nw0unO3eNs'
        },
        {
            image: Safety2,
            url: 'https://www.youtube.com/embed/_Z5ffdIABXY'
        },
        {
            image: Safety3,
            url: 'https://www.youtube.com/embed/1i0p9DaOHCU'
        },
        {
            image: Safety4,
            url: 'https://www.youtube.com/embed/9BGa6dMqIOg'
        },
        {
            image: Safety5,
            url: 'https://www.youtube.com/embed/UahIuo22IC8'
        },
        {
            image: Safety6,
            url: 'https://www.youtube.com/embed/sPDjqZS2fso'
        },
    ],
    ImpactOnCultureAndOperations: [
        {
            image: ImpactOnCultureAndOperations1,
            url: 'https://www.youtube.com/embed/_cWLMPdbnr8'
        },
        {
            image: ImpactOnCultureAndOperations2,
            url: 'https://www.youtube.com/embed/Eb2PXrFwiAI'
        },
        {
            image: ImpactOnCultureAndOperations3,
            url: 'https://www.youtube.com/embed/TLCDl3gEEiM'
        },
        {
            image: ImpactOnCultureAndOperations4,
            url: 'https://www.youtube.com/embed/v6IZlpqshWw'
        },
        {
            image: ImpactOnCultureAndOperations5,
            url: 'https://www.youtube.com/embed/zzJ4zI3QP5Q'
        },
        {
            image: ImpactOnCultureAndOperations6,
            url: 'https://www.youtube.com/embed/rLBP3lrh-3c'
        },
        {
            image: ImpactOnCultureAndOperations7,
            url: 'https://www.youtube.com/embed/z9KRfnn46GU'
        },
        {
            image: ImpactOnCultureAndOperations8,
            url: 'https://www.youtube.com/embed/hsPlPIc3tm8'
        },
        {
            image: ImpactOnCultureAndOperations9,
            url: 'https://www.youtube.com/embed/zzdadfXp2kw'
        },
        {
            image: ImpactOnCultureAndOperations10,
            url: 'https://www.youtube.com/embed/CARs5Z00O7I'
        },
        {
            image: ImpactOnCultureAndOperations11,
            url: 'https://www.youtube.com/embed/WKYheWc-x-k'
        },
        {
            image: ImpactOnCultureAndOperations12,
            url: 'https://www.youtube.com/embed/HcvfnvElWdQ'
        },
        {
            image: ImpactOnCultureAndOperations13,
            url: 'https://www.youtube.com/embed/NtcDTSa9Rbo'
        },
        {
            image: ImpactOnCultureAndOperations14,
            url: 'https://www.youtube.com/embed/G-zjhqSrZBA'
        },
        {
            image: ImpactOnCultureAndOperations15,
            url: 'https://www.youtube.com/embed/mTbQ-mPqbDg'
        },
        {
            image: ImpactOnCultureAndOperations16,
            url: 'https://www.youtube.com/embed/JQj356LoMMs'
        },
    ],
    CustomerServiceAndSatisfication: [
        {
            image: CustomerServiceAndSatisfaction1,
            url: 'https://www.youtube.com/embed/FRqL2jI-d8M'
        },
        {
            image: CustomerServiceAndSatisfaction2,
            url: 'https://www.youtube.com/embed/kmUIggxECuU'
        },
        {
            image: CustomerServiceAndSatisfaction3,
            url: 'https://www.youtube.com/embed/Nta0hXF32XY'
        },
        {
            image: CustomerServiceAndSatisfaction4,
            url: 'https://www.youtube.com/embed/nE9hZFfuOxo'
        },
        {
            image: CustomerServiceAndSatisfaction5,
            url: 'https://www.youtube.com/embed/in9OV4p2JwI'
        }
    ]
}

const CustomerStoriesData = [
    {
        id: 13,
        title: `CUSTOMER STORIES`,
        content: 'Our customers’ success stories speak for themselves — see firsthand how Drivosity is enhancing delivery operations at every level.',
        location: `/customer-stories`,
        data: null,
    },
    {
        id: 13,
        title: ``,
        content: 'At Drivosity, we are confident that our solutions are the top choice for safety, productivity, and operational efficiency in last-mile delivery. Scroll to hear directly from franchisees, operators, managers, and drivers who are benefiting from it.',
        location: `/customer-stories`,
        data: null,
    },
    {
        id: 13,
        title: ``,
        content: `
            Delivering Great Drivers,
            Some of Our Fans,
            Financial Benefits,
            How Drivosity Helps,
            Productivity,
            Safety,
            Impact On Culture and Operations,
            Customer Service and Satisfication
        `,
        location: `/customer-stories`,
        data: null,
    },
];

export {videos, CustomerStoriesData};
